module.exports = __webpack_public_path__ + "static/img/tatal-dayDefault.b52e784a.png";